import { assign, identity, trim } from 'lodash';
import URL from 'url-parse';
import isAbsolute from 'is-absolute-url';

const getUrlParts = (rawUrl, configs) => {
  if (rawUrl.indexOf(configs.baseUrl) !== 0 && configs.strictBaseUrl) {
    throw new Error(`API requests are restricted to this 'baseUrl': ${configs.baseUrl}`);
  }

  const url = new URL(rawUrl);

  return {
    url: url.origin,
    path: url.pathname,
  };
};

export default (configs = {}) => (request) => {
  const path = trim(request.path, ' /');

  if (isAbsolute(path)) {
    assign(request, getUrlParts(path, configs));
  }

  return identity;
};



// WEBPACK FOOTER //
// ./src/Api/middleware/normalizeUrl.js